import { object, string } from 'yup'
import { t } from '@lingui/macro'

import { OrganisationRoleEnum } from '../../../../../../types/Organisation'
import { ICreateUserInput } from './types/CreateUserInput'

const allowedOrgRoles = [
  OrganisationRoleEnum.ADMIN,
  OrganisationRoleEnum.STUDENT
]

export const initialCreateUserData = (): ICreateUserInput => ({
  email: '',
  first_name: '',
  last_name: '',
  organisation_role: OrganisationRoleEnum.STUDENT,
  position: '',
  groupId: ''
})

export const initialCreateAccountNameData = (): ICreateUserInput => ({
  email: '',
  account_name: '',
  first_name: '',
  last_name: '',
  organisation_role: OrganisationRoleEnum.STUDENT,
  position: '',
  groupId: ''
})
// @ts-expect-error
export const CreateUserSchema = object<ICreateUserInput>().shape({
  email: string()
    .email(t`Invalid email`)
    .required(t`Required`),
  first_name: string()
    .required(t`Required`)
    .min(2),
  last_name: string()
    .required(t`Required`)
    .min(2),
  organisation_role: string().oneOf(allowedOrgRoles)
})

// @ts-expect-error
export const CreateUserSchemaAccountName = object<ICreateUserInput>().shape({
  email: string().email(t`Invalid email`),
  account_name: string().min(2),
  first_name: string()
    .required(t`Required`)
    .min(2),
  last_name: string()
    .required(t`Required`)
    .min(2),
  organisation_role: string().oneOf(allowedOrgRoles)
})
